"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketRequestPaymentInput_1 = require("./GetBucketRequestPaymentInput");
var GetBucketRequestPaymentOutput_1 = require("./GetBucketRequestPaymentOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketRequestPayment = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketRequestPayment",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?requestPayment"
    },
    input: {
        shape: GetBucketRequestPaymentInput_1.GetBucketRequestPaymentInput
    },
    output: {
        shape: GetBucketRequestPaymentOutput_1.GetBucketRequestPaymentOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketRequestPayment.js.map